import { Component, Input } from '@angular/core';
import { getLanguageCookie } from 'src/assets/language';
import { MatTableDataSource } from '@angular/material/table';
import { v4 } from "uuid";
import moment from 'moment';
import { arrayIsSap } from 'src/assets/const/arrayYesNo';
@Component({
  selector: 'app-fte',
  templateUrl: './fte.component.html',
  styleUrls: ['./fte.component.scss']
})
export class FteComponent {
  @Input() parameters: any = {
    item: {
      label: '',
      fte: {
        months: []
      }
    }
  }
  @Input() dimensions: any = {}

  minDate: Date = new Date(2000, 0, 1);
  
  dataSource!: MatTableDataSource<any>;
  displayedColumns: string[] = ['month', 'fte', 'observation', 'action'];
  currentPage = 1;
  currentPageReq = 1;
  itemsPerPage = 10;

  arrayIsSap: any = arrayIsSap

  constructor(
  ) {
    this.dataSource = new MatTableDataSource();
  }

  async ngOnInit(){
    if (this.parameters?.item?.fte_tab?.months) {
      this.dataSource.data = this.parameters.item.fte_tab.months;
    }

    if(this.parameters.item.fte_tab.isSap !== 'yes'){
      this.parameters.item.fte_tab.isSap = 'no'
    }

    if(this.parameters.item.fte_tab.arbitrary_value == '' || this.parameters.item.fte_tab.arbitrary_value == null){
      this.parameters.item.fte_tab.arbitrary_value = '0,00'
    }

    if(this.parameters.item.fte_tab.real_value == '' || this.parameters.item.fte_tab.real_value == null){
      this.parameters.item.fte_tab.real_value = '0,00'
    }
  }

  allowNumbersOnly(event: Event) {
    const input = event.target as HTMLTextAreaElement;
    const value = input.value;
    

    // Remove qualquer caractere que não seja número ou ponto decimal
    const newValue = value.replace(/[^0-9.]/g, '');
    // Garante que só tenha um ponto decimal
    const parts = newValue.split('.');
    if (parts.length > 2) {
      input.value = parts[0] + '.' + parts.slice(1).join('');
    } else {
      input.value = newValue;
    }
  }

  formatCurrency(obj: any, key: string): void {
    let raw = (obj[key] || '').toString();
  
    // Remove separadores de milhar
    raw = raw.replace(/\./g, '');
  
    // Separa parte inteira e decimal
    let [intPart, decPart] = raw.split(',');
  
    // Garante que intPart tenha apenas dígitos
    intPart = (intPart.match(/\d+/g)?.join('') ?? '0');
  
    // Trata casas decimais
    if (!decPart) {
      decPart = '00';
    } else if (decPart.length === 1) {
      decPart = decPart + '0';
    } else {
      // Manter todas as casas decimais (sem truncar)
      decPart = decPart.replace(/[^\d]/g, '');
    }
  
    // Formata parte inteira com ponto a cada 3 dígitos
    const intFormatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  
    // Monta o valor final
    obj[key] = `${intFormatted},${decPart}`;
  }
  

  formatContent(event: Event, row: any): void {
    const textarea = event.target as HTMLTextAreaElement;
    let value = textarea.value;

    value = this.formatDecimalInput(value);

    row = value;
    this.autoResize(event, row);
  }

  formatDecimalInput(value: string): string {
    value = value.replace(',', '.');
    
    value = value.replace(/[^\d.]/g, '');
    
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('');
    }
    
    if (parts.length === 2) {
      parts[1] = parts[1].substring(0, 2);
      value = parts.join('.');
    }
    
    return value;
  }

  validateInput(event: KeyboardEvent): boolean {
    const char = event.key;
    // permite só dígito ou vírgula
    if (!/[\d,]/.test(char)) {
      event.preventDefault();
      return false;
    }
  
    const input = event.target as HTMLInputElement;
    // só uma vírgula
    if (char === ',' && input.value.includes(',')) {
      event.preventDefault();
      return false;
    }
  
    return true;
  }
  
  validateDateInput(event: KeyboardEvent): boolean {
    const charCode = event.charCode;
    const char = String.fromCharCode(charCode);

    if (!/[\d/]/.test(char)) {
      event.preventDefault();
      return false;
    }
    
    if (char === '/') {
      const textarea = event.target as HTMLTextAreaElement;
      if (textarea.value.includes('/')) {
        event.preventDefault();
        return false;
      }
    }

    return true;
  }

  onDateInputChange(event: Event) {
    // const input = event.target as HTMLInputElement;
    // let value = input.value.replace(/\D/g, '');

    // if (value.length > 8) {
    //   value = value.slice(0, 8); 
    // }

    // if (value.length > 4) {
    //   value = value.replace(/^(\d{2})(\d{2})(\d{0,4})/, '$1/$2/$3');
    //   // Verifica o ano
    //   const yearMatch = value.match(/(\d{2})\/(\d{2})\/(\d{4})/);
    //   if (yearMatch) {
    //     let year = parseInt(yearMatch[3]);
    //     if (year < 2000) year = 2000;
    //     value = `${yearMatch[1]}/${yearMatch[2]}/${year}`;
    //   }
    // } else if (value.length > 2) {
    //   value = value.replace(/^(\d{2})(\d{0,2})/, '$1/$2');
    // }

    // input.value = value;

    const input = event.target as HTMLTextAreaElement;
    let value = input.value;

    // Remove todos os caracteres exceto números e barras
    value = value.replace(/[^\d/]/g, '');
    // Se o valor estiver vazio, retorna vazio
    if (!value) {
      input.value = '';
      return;
    }
    value = this.formatDateInput(value);
    // Limita o tamanho total da string para DD/MM/AAAA (10 caracteres)
    if (value.length > 10) {
      value = value.substring(0, 10);
    }

    input.value = value;
  }

  onDateBlur(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;
  
    if (!value) return;
  
    const parts = value.split('/');
    if (parts.length === 3 && parts[2].length === 4) {
      let year = parseInt(parts[2]);
      if (year < 2000) {
        parts[2] = '2000';
        input.value = parts.join('/');
      }
    }
  }

  formatDateInput(value: string): string {
    let numbers = value.replace(/\D/g, '').substring(0, 8);
  
    if (numbers.length <= 2) {
      return numbers === '00' ? '01' : numbers;
    }
  
    if (numbers.length <= 4) {
      let day = numbers.substring(0, 2);
      let month = numbers.substring(2);
  
      if (day === '00') day = '01';
      if (parseInt(day) > 31) day = '31';
      if (month === '00') month = '01';
      if (parseInt(month) > 12) month = '12';
  
      return `${day}/${month}`;
    }
  
    // Aqui já temos ano começando
    let day = numbers.substring(0, 2);
    let month = numbers.substring(2, 4);
    let year = numbers.substring(4, 8); // Pode ter menos de 4 dígitos
  
    if (day === '00') day = '01';
    if (month === '00') month = '01';
  
    const monthInt = parseInt(month);
    let maxDay = 31;
    if ([4, 6, 9, 11].includes(monthInt)) {
      maxDay = 30;
    } else if (monthInt === 2) {
      maxDay = 29; // Validação final só no blur
    }
  
    if (parseInt(day) > maxDay) day = String(maxDay).padStart(2, '0');
    if (parseInt(month) > 12) month = '12';
  
    return `${day}/${month}/${year}`;
  }
  
  focusInput(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const input = target.querySelector('input');
    if (input) {
      input.focus();
    }
  }

  getNames(name: any){
    if (!name) return '';
    try {
      const language = localStorage.getItem('language');
      if (!language) return '';
      const decoded = atob(language);
      const parsed = JSON.parse(decoded);
      return name[parsed.lang] || '';
    } catch (error) {
      console.error('Erro ao processar idioma:', error);
      return '';
    }
  }

  getLanguages(file: string){
    return getLanguageCookie(file, localStorage.getItem('language'))
  }

  isData(){
    return this.dataSource.data.length > 0
  }

  getDisplayedRows(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.dataSource.data.slice(startIndex, endIndex);
  }

  getColumns(){
    return this.displayedColumns.slice(1)
  }

  getItemsPerPage(){
    return this.itemsPerPage
  }

  getCurrentPages(): number{
    return this.currentPage
  }

  choseItemsPage(number: number){
    this.itemsPerPage = number;
    this.getDisplayedRows()
  }

  onPageChange(newPage: number, text: string): void {
    this.currentPage = newPage;
  }

  getTotalPages(): number {
    return Math.ceil(this.dataSource.data.length / this.itemsPerPage);
  }

  async checkValue() {
    let total = this.getTotalPages()
    if (this.currentPage > total) this.currentPage = total;
  }

  formatDate(date: Date): string {
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  async newMonth(){
    if(!this.parameters.isEdit){
      return
    }

    const meses = [
      'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
      'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ];

    let proximoMes = '';
    
    if (this.dataSource.data.length === 0) {
      // Se não houver dados, usa o mês atual
      const dataAtual = new Date();
      proximoMes = meses[dataAtual.getMonth()];
    } else {
      // Encontra o último mês válido
      let ultimoMesValido = -1;
      for (let i = this.dataSource.data.length - 1; i >= 0; i--) {
        const mesAtual = this.dataSource.data[i].month;
        const indiceMes = meses.findIndex(m => m.toLowerCase() === mesAtual.toLowerCase());
        if (indiceMes !== -1) {
          ultimoMesValido = indiceMes;
          break;
        }
      }

      if (ultimoMesValido === -1) {
        const dataAtual = new Date();
        proximoMes = meses[dataAtual.getMonth()];
      } else {
        const proximoIndice = (ultimoMesValido + 1) % 12;
        proximoMes = meses[proximoIndice];
      }
    }

    let newMonth = {
      uuid: v4(),
      month: proximoMes,
      fte: 0,
      observation: '',
    };
    this.dataSource.data.push(newMonth);
  }

  choseItemSelect(type: string, value: any, element?: any){
    switch (type) {
      case 'isSap':
        this.parameters.item.fte_tab.isSap = value.slug
        break;
      default:
        break;
    }
  }

  getName(item: any){
    return this.getNames(item?.name) || this.getLanguages('select')
  }

  async deleteMonth(uuid: string) {
    if(!this.parameters?.isEdit){
      return
    }

    this.dataSource.data = this.dataSource.data.filter(item => item.uuid !== uuid);
    
    // Atualizar os meses no parameters apenas se a estrutura existir
    if (this.parameters?.item?.fte_tab) {
      this.parameters.item.fte_tab.months = this.dataSource.data;
    }
  }

  getSumFte(){
    let sum = 0
    this.dataSource.data.forEach(item => {
      const fteValue = parseFloat(item.fte)
      if (isNaN(fteValue)) {
        item.fte = 0
        sum += 0
      } else {
        sum += fteValue
      }
    })
    // Arredonda para 1 casa decimal
    return Number(sum.toFixed(1))
  }

  autoResize(event: Event, row?: any): void {
    const textarea = event.target as HTMLTextAreaElement;
    const tr = textarea.closest('tr');
    
    if (!tr) {
      return;
    }

    const textareas = tr.querySelectorAll('textarea');
    let maxHeight = 0;

    textareas.forEach((ta: HTMLTextAreaElement) => {
      ta.style.height = 'auto'; 
      const taHeight = ta.scrollHeight;
      if (taHeight > maxHeight) {
        maxHeight = taHeight;
      }
    });

    textareas.forEach((ta: HTMLTextAreaElement) => {
      ta.style.height = `${maxHeight}px`;
    });
  }

  adjustTextareaHeight(event: Event) {
    const textarea = event.target as HTMLTextAreaElement;
    if (!textarea) return;
    
    // Reset height
    textarea.style.height = 'auto';
    
    // Set new height based on content
    const newHeight = Math.max(textarea.scrollHeight, 7 * 16); // 7vh em pixels (assumindo 16px = 1vh)
    textarea.style.height = newHeight + 'px';
    
    // Ajustar altura da linha
    const tr = textarea.closest?.('tr');
    if (tr) {
      tr.style.height = newHeight + 'px';
    }
  }
}
